import { render, staticRenderFns } from "./ItemsGridContainerV2.vue?vue&type=template&id=e2df0586&scoped=true&"
import script from "./ItemsGridContainerV2.vue?vue&type=script&lang=js&"
export * from "./ItemsGridContainerV2.vue?vue&type=script&lang=js&"
import style0 from "./ItemsGridContainerV2.vue?vue&type=style&index=0&id=e2df0586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2df0586",
  null
  
)

export default component.exports